import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('a-tabs', {
    staticClass: "mb-10",
    attrs: {
      "animated": false
    },
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, _vm._l(_vm.visibleTabs, function (tab) {
    return _c('a-tab-pane', {
      key: _vm.resolveTabKey(tab),
      attrs: {
        "data-sign": "batch_inventory_list_" + _vm.resolveTabKey(tab),
        "tab": _vm.t(tab.text + $t("\u67E5\u8BE2"))
      }
    }, [_vm.activeTab === _vm.resolveTabKey(tab) ? _c(_vm.resolveTabKey(tab), _vm._b({
      tag: "component"
    }, 'component', _vm.getComponentProps(tab), false)) : _vm._e()], 1);
  }), 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };